<template>
  <div class="flex flex-wrap">
    <div
      v-for="option in options"
      :key="option.value"
      class="px-16 h-40 rounded-md border flex items-center mr-8 mb-8 cursor-pointer base"
      :class="{
        'border-primary-default bg-primary-default': selected.includes(option.value),
        'border-border': !selected.includes(option.value),
        'text-white': !darkText && selected.includes(option.value),
        'text-black': darkText && selected.includes(option.value),
      }"
      @click="setValue(option.value)"
    >
      {{ option.value }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useUserStore } from '@/store/user';
import { storeToRefs } from 'pinia';

const props = defineProps<{
  options: any[];
  value: string | null;
}>();

const emits = defineEmits<{
  (e: 'onInput', payload: string): void
}>();

const userStore = useUserStore();
const { darkText } = storeToRefs(userStore);

const selected = ref<string[]>(props.value?.split('|') || []);

const setValue = (value: string) => {
  if (selected.value.includes(value)) {
    selected.value = selected.value.filter(selectedValue => selectedValue !== value);
  } else {
    selected.value = [...selected.value, value];
  }

  emits('onInput', selected.value.join('|'));
};

</script>
<style scoped>

.checkbox-input__item {
  padding: 8px 12px;
  border: 1px solid gray;
  margin-right: 8px;
  margin-bottom: 8px;
}

.checkbox-input__item.selected {
  border-color: red;
}
</style>
